export default __webpack_public_path__ + "static/media/background-eye.f76d2495.png";